import { Col, Container, Image, Row } from "react-bootstrap";
import { Building, EnvelopeFill, FileCodeFill, GeoAlt, Github, Linkedin, Twitter } from "react-bootstrap-icons";

import './About.css';

function Avout() {

    return (
        <>
            <Container>
                <Row className='d-flex flex-row-reverse m-1'>
                    <Col md={4} className=''>
                        <div className='bg-light p-3 mb-3'>
                            <div className='text-center'>
                                <Image src='/assets/avatar.png' className='rounded' style={{ width: "180px" }}></Image>
                            </div>
                            <hr />
                            <h4 className='about-profile-title'>Profile</h4>
                            <h5>91d906h4</h5>
                            <p>
                                <a href='https://github.com/w38smtvk' className='text-black text-decoration-none' target='_blank' rel='noreferrer'><Building></Building> @w38smtvk</a><br />
                                <GeoAlt></GeoAlt> Earth, Anywhere<br />
                                <Github></Github> <a href='https://github.com/91d906h4' className='text-black text-decoration-none' target='_blank' rel='noreferrer'>91d906h4</a>
                            </p>
                            <hr />
                            <h4 className='about-profile-title'>Contact Me</h4>
                            <p>
                                <a href='https://www.linkedin.com/in/幸彦-鈴木-65a24323a/' className='text-black text-decoration-none' target='_blank' rel='noreferrer'><Linkedin></Linkedin> LinkedIn</a><br />
                                <a href='https://leetcode.com/91d906h4' className='text-black text-decoration-none' target='_blank' rel='noreferrer'><FileCodeFill></FileCodeFill> LeetCode</a><br />
                                <a href='https://twitter.com/91d906h4' className='text-black text-decoration-none' target='_blank' rel='noreferrer'><Twitter></Twitter> Twitter</a><br />
                                <a href='mailto:fairymanning@gmail.com' className='text-black text-decoration-none' target='_blank' rel='noreferrer'><EnvelopeFill></EnvelopeFill> E-Mail</a>
                            </p>
                            <hr />
                            <h4 className='about-profile-title'>Experience</h4>
                            <p>
                                <strong>2015/05</strong> - My first program with Visual Basic.<br />
                                <strong>2021/07</strong> - Back-End Developer (PHP)<br />
                                <strong>2022/08</strong> - Front-End Developer (React)<br />
                                <strong>2023/03</strong> - Software Engineer (C/C++)<br />
                            </p>
                        </div>
                    </Col>
                    <Col md={8}>
                        <div className='about-selfintro-text'>
                            <h2>Hello, World!</h2>
                            <p>
                                &emsp;Hi! I'm 91d906h4. This is my blog. It records my recent works and some ideas.
                                If you want, you can find my contact details on this page.
                            </p>
                            <br />
                            <h2>Me and Computer</h2>
                            <h4>Programming Language</h4>
                            <p>
                                &emsp;The first programming language I learned is Visual Basic.
                                When I realized that I can do something interesing just with a few lines of code, I ware totally attracted!
                            </p>
                            <p>
                                &emsp;But in the next few years,
                                I didn't keep improving my programming skills because I realized that VB could not satisfy my curiosity any more,
                                and I didn't know that there are amount of other programming language in the world.
                            </p>
                            <p>
                                &emsp;I went back to programming when I was a freshman. I learned C++ in college.
                                Actually, it made me feel frustrated because I couldn't pass some exam.
                                But my passion of coding has never fade away! I googled about programming language,
                                and I found something caught my eye - that is WEB!
                            </p>
                            <p>
                                &emsp;At the beginning of my "programming career", I made some HTML static websites,
                                but soon I found that HTML can only do very few things. Then I met JavaScript and PHP.
                                Them made my website alive! And also they are so easy that I got a sense of accomplishment from them.
                            </p>
                            <p>
                                &emsp;Then I made a lot of PHP website. After a half year,
                                I faced a problem - the extensibility of pure PHP website limited the capability to make larger one.
                                So I started using the frameworks.
                            </p>
                            <p>
                                &emsp;About 1 year later, I recognized that PHP is despised by everyone. Because it's too easy to learn
                                and the poor design. (Everybody says so ..., but I still think PHP is an awesome programming language)
                                So, I decided to learn a "real programming language", C/C++, which is the ancestor of almost all
                                programming languages.
                            </p>
                            <p>
                                &emsp;On the journey of learning C/C++, I met assembly language, which is respected by evey programer.
                                To learn assembly language, I also built my own <a href="https://github.com/91d906h4/HOS" target="_blank">operating system</a> and
                                a <a href="https://github.com/91d906h4/nun-lang" target="_blank">tiny programming language</a>.
                                (If you are interested in the compiler built by me, you can check the repository of <a href="https://github.com/91d906h4/HIC" target="_blank">HIC</a>,
                                it can even calculate the Fibonacci sequence using both DP and recursoin)
                            </p>
                            <p>
                                &emsp;After creating my own compiler, I got a little tired of coding. So now I started to learn the knowledge of hardware.
                            </p>
                            <br />
                            <h2>About Me</h2>
                            <p>
                                &emsp;I am an enthusiastic, self-motivated, reliable, responsible and hard working person.
                                I am a mature team worker and adaptable to all challenging situations.
                                I am able to work well both in a team environment as well as using own initiative.
                                I am able to work well under pressure and adhere to strict deadlines.
                            </p>
                            <br />
                            <h2>Skills</h2>
                            <p>
                                &emsp;I'm currently studying for machine learning, Web3 technologies such as blockchain and distributed
                                computing, and IC designing.
                                As my interest, I'm familar with React (This website is built with React), Laravel, and Django.
                            </p>
                            <p>
                                &emsp;Apart from programming languages, I'm also interested in human languages.
                                I passed JLPT (日本語能力試験) N1 and BJT (BJTビジネス日本語能力テスト) J2 when I were sophomore.
                                And now, I'm studying for TOPIK (함국어능력시험).
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Avout;